export default __webpack_public_path__ + "static/media/img-0043.7692f337.png";